import './lib/polyfills/IE11';
import { checkBrowserFeatures, shouldLog } from './lib/helpers';

if (shouldLog) require('logrocket').init('daupnu/mgmw');

if (checkBrowserFeatures()) import('./MGMW').catch(err => console.error(err));
else import('./UnsupportedBrowser').catch(err => console.error(err));
